import { Vector3 } from '@babylonjs/core/Maths/math.vector';
import { Token, TransformFeature } from '@models/classes';
import { SubmeshVertexData } from '@view/helpers/geometry-helper';
import { FeatureRenderer } from './feature';

export class TransformRenderer extends FeatureRenderer<TransformFeature> {
    modelToken = Token.TransformFeature;
    updateMeshGeometry(
        feature: TransformFeature,
        vertexData: SubmeshVertexData,
        vertexDataChanges: Partial<SubmeshVertexData>
    ) {
        const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);
        const parentMesh = feature._parent;

        if (parentMesh && newVertexData.positions && newVertexData.positions.length > 0) {
            const newMeshVertexPositions = newVertexData.positions;
            const indexCount = newMeshVertexPositions.length / 3;
            const pivot = parentMesh.pivot.toVec3();
            const vertexPosition = new Vector3();

            let scaleVector: Vector3 | undefined;
            if (!feature.scale.equal({ x: 1, y: 1, z: 1 })) {
                scaleVector = feature.scale.toVec3();
            }

            for (let i = 0; i < indexCount; i++) {
                if (pivot && scaleVector) {
                    vertexPosition.copyFromFloats(
                        newMeshVertexPositions[i * 3] - pivot.x,
                        newMeshVertexPositions[i * 3 + 1] - pivot.y,
                        newMeshVertexPositions[i * 3 + 2] - pivot.z
                    );

                    if (scaleVector) {
                        vertexPosition.multiplyInPlace(scaleVector);
                    }

                    vertexPosition.addInPlace(pivot);

                    newMeshVertexPositions[i * 3] = vertexPosition.x;
                    newMeshVertexPositions[i * 3 + 1] = vertexPosition.y;
                    newMeshVertexPositions[i * 3 + 2] = vertexPosition.z;
                }
            }
        }

        return newVertexData;
    }

    update3dInternal() {}
}
